// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"a03f2823","1212":"7cb5c824","5668":"36e8267b","5969":"570f2b94","7853":"36e8267b","9721":"3a06b1b7"}[chunkId] + ".chunk.css";
};